"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const __1 = require("..");
const utils_1 = require("../utils");
/**
 * Set status of order to IN_PROGRESS
 * Can only be done when the order is in CREATED status
 * @param event
 * @param prevState
 */
function default_1(event, prevState = {}) {
    const order = (0, utils_1.clone)(prevState);
    if (prevState.status === domain_1.OrderStatus.CREATED && event.timestamp) {
        order.createdAt = event.timestamp;
    }
    (order.orderItems || []).forEach(item => {
        var _a, _b, _c;
        if (((_a = item.comboItems) === null || _a === void 0 ? void 0 : _a.length) &&
            item.comboItems.some(i => i.status === domain_1.OrderItemStatus.CREATED)) {
            item.status = domain_1.OrderItemStatus.IN_PROGRESS;
            //Update combo item status
            (_b = item.comboItems) === null || _b === void 0 ? void 0 : _b.forEach(comboItem => {
                if (comboItem.status === domain_1.OrderItemStatus.CREATED)
                    comboItem.status = domain_1.OrderItemStatus.IN_PROGRESS;
            });
        }
        else if (!((_c = item.comboItems) === null || _c === void 0 ? void 0 : _c.length) &&
            item.status === domain_1.OrderItemStatus.CREATED) {
            item.status = domain_1.OrderItemStatus.IN_PROGRESS;
        }
        item.saved = true;
    });
    if (prevState.status === domain_1.OrderStatus.CREATED) {
        order.status = domain_1.OrderStatus.IN_PROGRESS;
    }
    if (prevState.status === domain_1.OrderStatus.IN_PROGRESS) {
        order.isEdited = true;
    }
    if (order.orderItems) {
        order.orderItems = (0, __1.mergeIdenticalOrderItems)(order.orderItems);
    }
    (order.adjustments || []).forEach(adj => {
        if (adj.adjustmentType == domain_1.AdjustmentType.REWARD) {
            adj.saved = true;
        }
    });
    return order;
}
exports.default = default_1;
//# sourceMappingURL=saveOrder.js.map